import { render, staticRenderFns } from "./terms-service.vue?vue&type=template&id=0d3e2e62&scoped=true&"
import script from "./terms-service.vue?vue&type=script&lang=js&"
export * from "./terms-service.vue?vue&type=script&lang=js&"
import style0 from "./terms-service.vue?vue&type=style&index=0&id=0d3e2e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e2e62",
  null
  
)

export default component.exports